export default __webpack_public_path__ + "static/media/AzureDevOpsBoards.50312d88.svg";